import { CampaignDetailsResponse, CampaignRequest } from '../../api-models';
import { CampaignInformation } from '../../types/campaigns.type';
import { Channel, HTTPMethod } from '../../types/enums';
import { SelectedFilters } from '../../types/filters.type';
import { AdapterInterface } from '../../types/global';
import { getCampaign } from '../../utils/campaign';
import { snakeCase } from '../../utils/formatters';
import adaptFilterRequest from './adaptFilterRequest';

import BaseAdapter from './baseAdapter';

export default class PostAddCampaign extends BaseAdapter<CampaignDetailsResponse[]> implements AdapterInterface {
  rawResponse: CampaignDetailsResponse[];

  modifiedRequest: CampaignRequest;

  async adaptResponse(request: { id: string, selectedFilters: SelectedFilters }): Promise<CampaignInformation[]> {
    const formattedRequest = this.adaptRequest(request);

    await this.fetchApiResponse('/api/add-campaign', HTTPMethod.Post, formattedRequest);

    return this.rawResponse.map((campaign) => ({
      campaignCommunicationId: campaign.campaign_communication_id,
      campaignName: campaign.name,
      campaignType: campaign.benefit_name || 'custom',
      communicationChannel: campaign.channel,
      snapshot: campaign.snapshot,
      status: campaign.status,
      numberOfRecipients: campaign.number_of_recipients,
      createdBy: campaign.created_by,
      reviewed: campaign.reviewed,
    }));
  }

  adaptRequest(request: { id: string, selectedFilters: SelectedFilters }): CampaignRequest {
    const campaignData = getCampaign(request.id);
    const adaptedFilters = adaptFilterRequest(request.selectedFilters);

    this.modifiedRequest = {
      campaign_name: campaignData.campaignName,
      benefit_name: snakeCase(campaignData.campaignType),
      snapshot: campaignData.snapshot,
      channel_name: campaignData.communicationChannel === Channel.Letter ? Channel.BackendLetter : campaignData.communicationChannel.toLowerCase(),
      stagger: campaignData.stagger, // set to false in campaign store until stagger is implemented
      sms_template_id: campaignData.smsTemplateId,
      template_s3_key: campaignData.letterTemplateId,
      dispatch_date: campaignData.dispatchDate,
      filter_request_list: adaptedFilters.filter_request_list,
      dynamic_filter_request_list: adaptedFilters.dynamic_filter_request_list,
    };
    return this.modifiedRequest;
  }
}
